export default {
  name: 'Call to action section - 6',
  tab: 'call to action',
  type: 'content-default-section',
  content: {
    title: 'Call to action',
    introtext:
      '<p>Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus. Vestibulum id ligula porta felis euismod semper.</p>',
    image: '',
    buttons:
      '[{"button-text":"Call to action","button-link":"https://www.google.com","button-style":"default","button-background-color":"var(--accent-color)","button-text-color":"var(--secondary-color)"},{"button-style":"outlined","button-background-color":"var(--accent-color)","button-text-color":"var(--text-light-color)","button-text":"External link","button-link":"#"}]'
  },
  design: {
    'background-color': 'var(--background-color)',
    'background-image': '/storage/media/samples/pexels-jan-kopřiva-3614358.jpg',
    'background-image-tablet': '',
    'background-image-mobile': '',
    'parallax-background-image': '0',
    'custom-padding': '1',
    'padding-top': '100px',
    'padding-bottom': '100px',
    'title-color': 'var(--text-light-color)',
    'title-font-weight': 'var(--title-font-weight)',
    'title-tag': 'h3',
    'introtext-color': 'var(--text-light-color)'
  },
  layout: {
    'content-container-fluid': '0',
    'content-container-size': 'md',
    'content-horizontal-alignment': 'end',
    'content-box': '1',
    'content-box-color': 'var(--secondary-color)',
    'content-box-padding': '40px',
    'content-box-opacity': '1',
    'content-box-elevation': '16',
    'content-box-border': '0',
    'content-box-border-color': 'inherit',
    'content-box-rounded': '1',
    'content-vertical-alignment': 'start',
    'image-size': 'sm',
    'image-position': 'left'
  },
  advanced: {}
}
